/**
 * RetirementSummaryLine Component
 * WP-RETIRE-2: Collapsed state summary showing key metrics
 */

import { formatCurrency, formatCurrencyCompact } from '@/utils/format';
import type { RetirementPlanningInputs, RetirementNetWorth } from '@/types/retirement';

interface RetirementSummaryLineProps {
  inputs: RetirementPlanningInputs;
  netWorth: RetirementNetWorth | null;
}

export default function RetirementSummaryLine({
  inputs,
  netWorth,
}: RetirementSummaryLineProps) {
  const totalNetWorthCents =
    (netWorth?.totalCents ?? 0) + (inputs.netWorthAdjustmentCents ?? 0);
  const expensesDollars = inputs.retirementExpensesAnnualCents / 100;

  // Determine retirement status text
  const isAlreadyRetired = inputs.currentAge >= inputs.retirementAge;
  const ageText = isAlreadyRetired
    ? `Retired at ${inputs.retirementAge}`
    : `Age ${inputs.currentAge} -> Retire at ${inputs.retirementAge}`;

  return (
    <div className="px-4 py-2 text-sm text-gray-600 flex flex-wrap gap-x-4 gap-y-1">
      <span>
        <span className="font-medium text-gray-900">Current: </span>
        {ageText}
      </span>
      <span>
        <span className="font-medium text-gray-900">Net Worth: </span>
        {formatCurrencyCompact(totalNetWorthCents)}
      </span>
      <span>
        <span className="font-medium text-gray-900">Expenses: </span>
        {formatCurrency(expensesDollars)}/yr
      </span>
    </div>
  );
}
